import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  ButtonGroup,
} from "shards-react";
import PageTitle from "../components/common/PageTitle";
import { TextField, Typography, Button as ButtonMui, CircularProgress } from "@mui/material";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import axios from "axios";

const MetaDashboard = () => {
  const { register, handleSubmit } = useForm({ shouldUnregister: true });
  const { register: register1, handleSubmit: handleSubmit1 } = useForm({
    shouldUnregister: true,
  });
  const cardClasses = classNames("stats-small");
  const cardBodyClasses = classNames();

  const base_url = "https://back.clubside.tacverse.com/api";
  // const base_url = "http://localhost:8000/api";

  const [project, setProject] = useState(false);
  const [platForm, setPlatForm] = useState(false);
  const [data, setData] = useState([]);
  const [metaData, setMetaData] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token") || false);

  useEffect(() => {
    axios.get(`${base_url}/meta`).then((res) => {
      setData(res.data);
      setPlatForm(Object.keys(res.data[0].data)[0]);
      setProject(res.data[0]);
      setMetaData(res.data[0].data[Object.keys(res.data[0].data)[0]]);
    });
  }, []);

  const handleClick = (name) => {
    const project = data.filter((item) => item.name === name)[0];
    setProject(project);
    setMetaData(
      data.filter((item) => item.name === project.name)[0].data[platForm]
    );
  };

  const handleClickPlatForm = (name) => {
    setPlatForm(name);
    setMetaData(
      data.filter((item) => item.name === project.name)[0].data[name]
    );
    setTimeout(setLoader(false), 5000);
  };

  const login = (data) => {
    axios.post(`${base_url}/login`, data).then((res) => {
      setToken(res.data.token);
      localStorage.setItem("token", res.data.token);
    });
  };

  const onSubmit = (formData) => {
    setIsLoading(true)
    const authAxios = axios.create({
      headers: {
        Accept: "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });

    authAxios
      .patch(`${base_url}/meta/${project._id}`, {
        name: project.name,
        data: { ...project.data, ...formData },
      })
      .then((res) => {
        const newData = data.filter((item) => item.name !== res.data.data.name);
        setProject(res.data.data);
        setData([...newData, res.data.data]);
      });
    setTimeout(() => {
      setIsLoading(false)
    }, 1500)
  };

  function capitalizeTitle(title) {
    return title.replace(/(?:^|\_)(\w)/g, function (char) {
      return char.toUpperCase();
    }).replace(/_/g, ' ').toUpperCase();;
  }

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      {token ? (
        <>
          {data.length <= 0 ? (
            <h4>No data found</h4>
          ) : (
            <>
              <Row noGutters className="page-header py-4">
                <h6>PROJECT:</h6>
                <ButtonGroup className={"mb-4 d-flex"}>
                  {data.map((item) => {
                    return (
                      <Button
                        onClick={() => handleClick(item.name)}
                        outline={project.name === item.name ? false : true}
                        size="lg"
                        style={{
                          color:
                            project.name === item.name ? "white" : "#A21C1C",
                          backgroundColor:
                            project.name === item.name ? "#A21C1C" : "",
                          borderColor: "#A21C1C",
                        }}
                      >
                        {item.name}
                      </Button>
                    );
                  })}
                </ButtonGroup>
                <h6>PLATFORM:</h6>
                <ButtonGroup className={"mb-4 d-flex"}>
                  {data &&
                    Object.keys(data[0].data).map((key) => {
                      return (
                        <Button
                          onClick={() => {
                            setLoader(true);
                            setTimeout(handleClickPlatForm(key), 5000);
                          }}
                          outline={platForm === key ? false : true}
                          size="lg"
                          style={{
                            color: platForm === key ? "white" : "#A21C1C",
                            backgroundColor: platForm === key ? "#A21C1C" : "",
                            borderColor: "#A21C1C",
                          }}
                        >
                          {key.toUpperCase()}
                        </Button>
                      );
                    })}
                </ButtonGroup>
              </Row>
              <form autocomplete="off" style={{ position: "relative" }} onSubmit={handleSubmit(onSubmit)}>
                {loader ? (
                  <></>
                ) : (
                  <>
                    {metaData && Object.keys(metaData).map((keyTitle) => (
                      <>
                        <PageTitle subtitle={capitalizeTitle(keyTitle)} />
                        <Row>
                          {Object.keys(metaData?.[keyTitle]).map((stats, idx) => (
                            <Col
                              className="col-3 mb-4"
                              key={`${platForm}-${keyTitle}-${idx}`}
                            >
                              <Card small className={cardClasses}>
                                <CardBody className={cardBodyClasses}>
                                  <Typography
                                    sx={{ mb: 1 }}
                                    variant="h6"
                                    component="h5"
                                  >
                                    {capitalizeTitle(stats)}
                                  </Typography>
                                  <TextField
                                    autocomplete="false"
                                    defaultValue={metaData?.[keyTitle][stats]}
                                    className="w-100"
                                    {...register(
                                      `${platForm}.${keyTitle}.${stats}`,
                                      {
                                        shouldUnregister: true,
                                        required: true,
                                      }
                                    )}
                                    label={capitalizeTitle(stats)}
                                    variant="outlined"
                                  />
                                </CardBody>
                              </Card>
                            </Col>
                          ))}
                        </Row>
                      </>))}
                  </>
                )}
                <ButtonMui type="submit" size="large" sx={{ "&:hover": { background: "#A21C1C", }, width: "100px", textAlign: "right", color: "white", background: "#A21C1C", position: "sticky", right: "10px", bottom: "10px" }}>
                  {isLoading ?
                    <CircularProgress color="inherit" /> :
                    "Save"
                  }
                </ButtonMui>
              </form>
            </>
          )}
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
          }}
        >
          <form style={{ width: "100%" }} onSubmit={handleSubmit1(login)}>
            <Row style={{ justifyContent: "center" }}>
              <Col sx={12} lg={4} className="col-lg mb-4">
                <Card small className={cardClasses}>
                  <CardBody className={cardBodyClasses}>
                    <Typography sx={{ mb: 1 }} variant="h6" component="h5">
                      Login
                    </Typography>
                    <TextField
                      className="w-100 mb-4"
                      {...register1("email", { required: true })}
                      label={"Email"}
                      variant="outlined"
                    />
                    <TextField
                      type={"password"}
                      className="w-100 mb-4"
                      {...register1("password", { required: true })}
                      label={"Password"}
                      variant="outlined"
                    />
                    <Button type="submit">Login</Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </form>
        </div>
      )}
    </Container>
  );
};

export default MetaDashboard;
